import { IconChevronDown } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { ButtonGroup, Menu, Text } from '@fragments';
import { CommunityBanner } from '@components/Community';

import './styles.scss';

const CURRENCY_OPTIONS = [
    { label: 'BRL', value: 'BRL' },
    { label: 'USD', value: 'USD' },
];

// A pill (matching the breadcrumb block) that sits beside the page nav: which
// community you're looking at, and which currency (national BRL / international
// USD) the per-currency sections show.
export default function CurrencyBar({
    ownedCommunities,
    community,
    setCommunity,
    plansByCommunity,
    selectedCurrency,
    setSelectedCurrency,
}) {
    const { t } = useTranslation('dashboard');

    const selected = ownedCommunities.find(c => c.id === community);

    const communityItems = ownedCommunities.map(c => {
        const hasPlans = (plansByCommunity?.[c.id] || []).length > 0;
        return {
            id: c.id,
            icon: <CommunityBanner banner={c.banner} size={24} />,
            label: hasPlans ? c.name : t('insights.currencyBar.noPlansSuffix', { name: c.name }),
            active: c.id === community,
            disabled: !hasPlans,
            onClick: () => setCommunity(c.id),
        };
    });

    return (
        <div className="insights-currency-bar">
            <Menu
                items={communityItems}
                placement="bottom-start"
                search={ownedCommunities.length > 6}
            >
                <button type="button" className="insights-currency-bar__community">
                    <CommunityBanner banner={selected?.banner} size={26} />
                    <Text.label contrast={9} maxLines={1}>
                        {selected?.name || t('common:actions.select')}
                    </Text.label>
                    <IconChevronDown size={16} className="insights-currency-bar__chevron" />
                </button>
            </Menu>

            <span className="insights-currency-bar__divider" aria-hidden="true" />

            <ButtonGroup
                options={CURRENCY_OPTIONS}
                value={selectedCurrency}
                onChange={setSelectedCurrency}
                size="small"
            />
        </div>
    );
}
